import React from 'react';
import { Target, Users, Trophy, Linkedin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="py-20 bg-gradient-to-br from-cyan-50 via-white to-purple-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
            {t.about.title}
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            {t.about.subtitle}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <FeatureCard
            icon={<Target className="w-8 h-8 text-cyan-600" />}
            title={t.about.mission}
            description={t.about.missionDesc}
          />
          <FeatureCard
            icon={<Users className="w-8 h-8 text-cyan-600" />}
            title={t.about.team}
            description={t.about.teamDesc}
          />
          <FeatureCard
            icon={<Trophy className="w-8 h-8 text-cyan-600" />}
            title={t.about.methodology}
            description={t.about.methodologyDesc}
          />
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div className="bg-white rounded-xl p-6 border border-cyan-100 hover:border-cyan-200 transition-all hover:shadow-lg">
            <div className="aspect-square w-48 mx-auto mb-6 overflow-hidden rounded-full border-4 border-cyan-100">
              <img
                src="https://lumilabs.es/assets/nerea.jpeg?auto=format&fit=crop&q=80&w=200"
                alt="Nerea Luis"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl font-semibold mb-3 text-center bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
              Nerea Luis
            </h3>
            <p className="text-gray-600 text-center mb-4">
              Co-fundadora
            </p>
            <p className="text-gray-600 mb-4">
              Doctora en Inteligencia Artificial con más de 10 años de experiencia en el sector tecnológico. Ha liderado proyectos de IA en consultoría así como manager y directora de equipo. Conocida divulgadora en TV, radio y redes sociales.
            </p>
            <div className="flex justify-center items-center text-cyan-600 hover:text-purple-600 transition-colors">
              <a href="https://linkedin.com/in/nerealuis" target="_blank" rel="noopener noreferrer" className="flex items-center">
                <Linkedin className="w-5 h-5 mr-2" />
                @sailormerqury
              </a>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-cyan-100 hover:border-cyan-200 transition-all hover:shadow-lg">
            <div className="aspect-square w-48 mx-auto mb-6 overflow-hidden rounded-full border-4 border-cyan-100">
              <img
                src="https://lumilabs.es/assets/clara.jpg?auto=format&fit=crop&q=80&w=200"
                alt="Clara de Luna"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-2xl font-semibold mb-3 text-center bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
              Clara de Luna
            </h3>
            <p className="text-gray-600 text-center mb-4">
              Co-fundadora
            </p>
            <p className="text-gray-600 mb-4">
              Máster en IA e ingeniera especialista en imagen y sonido con una trayectoria que combina la tecnología con el mundo artístico. Amplia experiencia en formación de IA generativa aplicada al sector audiovisual. Divulgadora sobre IA en redes. 
            </p>
            <div className="flex justify-center items-center text-cyan-600 hover:text-purple-600 transition-colors">
              <a href="https://linkedin.com/in/claradeluna" target="_blank" rel="noopener noreferrer" className="flex items-center">
                <Linkedin className="w-5 h-5 mr-2" />
                @claradeluna
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, title, description }: { icon: React.ReactNode; title: string; description: string }) => (
  <div className="text-center p-6 rounded-xl border border-cyan-100 hover:border-cyan-200 transition-all hover:shadow-lg bg-white">
    <div className="inline-block p-3 rounded-full bg-cyan-50 mb-4">
      {icon}
    </div>
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </div>
);

export default About;